@if (navLinks()?.children?.length) { @for (navLink of navLinks().children; track navLink) {
<li class="dropdown main-nav mob-dot-cms-main-custom-menu" [ngClass]="{ open: isOpened(navLink) }">
  @if (navLink?.type !== 'folder') {
  <!-- Normal link -->
  <a [routerLink]="dotCMSHeaderNavigationLink(navLink.href)">
    {{ navLink?.title }}
  </a>
  } @else { @if (navLink?.children?.length > 0) {
  <div
    #folder
    class="dropdown main-nav mob-dot-cms-custom-menu"
    [ngClass]="{ hover: false }"
    (mouseenter)="showFlyout(folder)"
    (mouseleave)="hideFlyout(folder)"
  >
    <custom-dot-cms-uve-header-folder-index-page-check [navLink]="navLink" />
    @if (mainNavigationMaxSubFoldersDepth > 0) {
    <a
      [routerLink]="[]"
      (click)="toggleOpen(navLink)"
      [attr.aria-label]="isOpened(navLink) ? 'collapse ' + navLink.title : 'expand ' + navLink.title"
      class="dropdown-toggle"
    >
      @if (isOpened(navLink)) {
      <fa-icon [icon]="['fas', 'minus']" />
      } @else {
      <fa-icon [icon]="['fas', 'plus']" />
      }
    </a>
    <custom-dot-cms-sub-folder-header-navigation [subFolderItems]="navLink.children" [depth]="1" />
    }
  </div>
  } @else {
  <div class="mob-dot-cms-custom-menu">
    <div class="mob-disable-links">{{ navLink.title }}</div>
  </div>
  } }
  <!-- Folder -->
</li>
} }
